import * as React from 'react'

import { withStyles } from '@material-ui/core'

const styles = () => ({
	root: {
		width: '100%',
		padding: '6px 0 7px',
		cursor: 'text',
	},
})


class StripeInput extends React.PureComponent {
	static displayName = 'StripeInput'
	static defaultProps = {
		onFocus: () => { },
		onBlur: () => { },
		onChange: () => { },
	}

	render() {
		const {
			classes: c,
			theme,
			component: Component,
			onFocus,
			onBlur,
			onChange,
		} = (this.props as any)

		return (
			<Component
				className={c.root}
				onFocus={onFocus}
				onBlur={onBlur}
				onChange={onChange}
				placeholder=""
				style={{
					base: {
						fontSize: `${theme.typography.fontSize}px`,
						fontFamily: theme.typography.fontFamily,
						color: '#000000de',
					},
				}}
			/>
		)
	}
}
export default withStyles(styles, { withTheme: true })(StripeInput)


// WEBPACK FOOTER //
// ./src/components/Checkout/StripeInput.tsx